/*========================================
        Imports!!!
=========================================*/

import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState, useEffect } from 'react';
import { useParams, useNavigate, generatePath } from 'react-router-dom';
import ReactMarkdown from "react-markdown";
import "../assets/css/story.css";

/*=======================================================
    ! Story Content
=======================================================*/

function Marks() {
    let { id } = useParams();
    const [markdown, setMarkdown] = useState(null);

  if (id > 6 || id < 1 || isNaN(id) === true) {
    id = 404;
  }

    useEffect(() => {
    fetch(`/assets/posts/post${id}.md`)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
    }, [id]);

    return (
        <>
            <ReactMarkdown>{markdown}</ReactMarkdown>
        </>
    );
}

/* shuffle random number from list  */

const RandNumb = () => {
    const { id } = useParams();
    const array = [1, 2, 3, 4, 5, 6].filter(n => n !== Number(id));
    const shuffled = array.sort(() => 0.5 - Math.random());
    return {
        liczba1: shuffled[0],
        liczba2: shuffled[1],
    };
};

const Connect = ({ numer1, numer2 }) => {
    const [short, setShort] = useState(null);
    const [short2, setShort2] = useState(null);
    let navigate = useNavigate({ replace: true })
  
    const route = () => {
      // location.reload(true);
      console.log(`navigate - ${numer1}`);
      window.scrollTo(0, 0);
      navigate(generatePath("/story/:id", { id: numer1 }));
    }

  const route2 = () => {
      console.log(`navigate - ${numer2}`);
      window.scrollTo(0, 0);
      navigate(generatePath("/story/:id", { id: numer2 }));
      // location.reload(true);
    }

    useEffect(() => {
        fetch(`/assets/shorts/short${numer1}.md`)
            .then((res) => res.text())
            .then((text) => setShort(text));
    },);

    useEffect(() => {
        fetch(`/assets/shorts/short${numer2}.md`)
            .then((res) => res.text())
            .then((text) => setShort2(text));
    },);

    function ClickedBut() {
        return (
          <>
            <Row className='title'>
                <Col>
                    <h2>Zobacz też!</h2>
                </Col> 
            </Row>
            <Row className='shorts'>
                <Col lg={6} md={6} sm={12} className='short'>
                  <button onClick={route}>
                    <ReactMarkdown>{short}</ReactMarkdown>
                  </button>
                </Col>
                <Col lg={6} md={6} sm={12} className='short'>
                  <button onClick={route2}>
                    <ReactMarkdown>{short2}</ReactMarkdown>
                  </button>
                </Col>
            </Row>
          </>
        );
    }
  
  return (
    <ClickedBut />
  );

};

function Short() {
  const { liczba1, liczba2 } = RandNumb();

  return (
    <>
      <Connect numer1={liczba1} numer2={liczba2} />
    </>
  );
}

function Story() {
    return (
        <>
            <Header />
            <article className='Contener'>
                <article className='Story'>
                <section className='markdowns'>
                    <Marks />
                </section>
                <section className='shorts'>
                    <Short />
                </section>
                </article>
            </article>
            <Footer />
        </>
    );
}

export default Story;